import rtkApis from '@rtkApis';
import parentApi from '../store/parentApi';
import { isKeycloakDisabledForPath } from '@/utility/helpers';

const postListingApis = parentApi.injectEndpoints({
  endpoints: (build) => ({
    postNewListing: build.mutation({
      query: (params) => rtkApis.postNewListing.query(params),
    }),
    getListingDetail: build.query({
      query: (params) => rtkApis.getListingDetail.query(params),
      transformResponse: (res, meta, args) => rtkApis.getListingDetail.transformer(res, meta, args),
    }),
    getUpsellDetail: build.query({
      queryFn: (params, api, extraOptions, baseQuery) =>
        rtkApis.getUpsellDetail.queryFn(params, api, extraOptions, baseQuery),
    }),
    getPriceCheck: build.query({
      query: (params) => rtkApis.getPriceCheck.query(params),
    }),
    getLicenseValidity: build.query({
      query: (adLicense) => `/api/listings/new_listing_data?ad_license_number=${adLicense}`,
    }),
    // getAutoGeneratedListingContent: build.query({
    //   query: (body) =>
    //     `/api/listings/${body?.listingId}/generate_content?${convertQueryObjToString(tenantPayloads.autoGeneratedListingContentPayload(body))}`,
    // }),
    getAutoGeneratedListingContent: build.query({
      query: (body) => rtkApis.getAutoGeneratedListingContent.query(body),
    }),
    updateListing: build.mutation({
      query: (params) => rtkApis.updateListing.query(params),
      invalidatesTags: (result, error) => {
        return (result && !isKeycloakDisabledForPath()) ? ['current', 'my-listings'] : [];
      },
    }),
    getLocationsBasedOnNational: build.query({
      query: (nationalAddress) => `/api/locations/google_location?address=${nationalAddress}`,
    }),
    postSavedListing: build.mutation({
      query: (query) => rtkApis.postSavedListing.query(query),
      async onQueryStarted(arg, api) {
        rtkApis.postSavedListing?.afterSuccess(arg, api);
      },
      transformResponse: (response, meta, arg) => rtkApis.postSavedListing.transformer(response, meta, arg),
    }),
    hideUnhideListings: build.mutation({
      query: (query) => rtkApis.hideUnhideListings.query(query),
      async onQueryStarted(arg, api) {
        rtkApis.hideUnhideListings?.afterSuccess(arg, api);
      },
      transformResponse: (response) => rtkApis.hideUnhideListings.transformer(response),
    }),
    getAmenities: build.query({
      query: (purposeId) => rtkApis.getAmenities.query(purposeId),
      transformResponse: (response) => rtkApis.getAmenities.transformer(response),
    }),
    // The same response unmapped ({ amenities: [{ type_id, groups: [{ features }] }] }), for
    // matching amenities by their English title. getAmenities maps titles to localised labels.
    getAmenitiesList: build.query({
      query: (purposeId) => rtkApis.getAmenities.query(purposeId),
    }),
    getQualityCriteria: build.query({
      query: (params) => rtkApis.getQualityCriteria.query(params),
      transformResponse: (response) => rtkApis.getQualityCriteria.transformer(response),
    }),
    fetchCrossCityDetail: build.query({
      query: (params) => rtkApis.fetchCrossCityDetail.query(params),
      transformResponse: (response) => rtkApis.fetchCrossCityDetail.transformer(response),
    }),
    getApplicableLicenses: build.query({
      query: (params) => '/api/licenses/applicable_licenses',
      transformResponse: (response) =>
        response?.data?.licenses?.length ? response?.data?.licenses?.map((e) => ({ ...e, key: e?.id })) : [],
    }),
    sendLicenseOtp: build.mutation({
      query: (body) => ({
        url: '/api/listings/send_otp',
        method: 'POST',
        body,
      }),
    }),
    verifyLicenseOtp: build.mutation({
      query: (body) => ({
        url: '/api/listings/verify_otp',
        method: 'POST',
        body,
      }),
      transformErrorResponse: (response) => response,
    }),
  }),
});

export const {
  usePostNewListingMutation,
  useLazyGetPriceCheckQuery,
  useHideUnhideListingsMutation,
  usePostSavedListingMutation,
  useLazyGetListingDetailQuery,
  useGetListingDetailQuery,
  useLazyGetLicenseValidityQuery,
  useLazyGetAutoGeneratedListingContentQuery,
  useUpdateListingMutation,
  useLazyGetLocationsBasedOnNationalQuery,
  useLazyGetAmenitiesQuery,
  useLazyGetAmenitiesListQuery,
  useLazyFetchCrossCityDetailQuery,
  useLazyGetUpsellDetailQuery,
  useGetUpsellDetailQuery,
  useGetApplicableLicensesQuery,
  useGetQualityCriteriaQuery,
  useSendLicenseOtpMutation,
  useVerifyLicenseOtpMutation,
} = postListingApis;
